import AuthService from './auth-service';
import {CsrfCookieRequestError} from './errors';
import httpClient from '@/services/http-client';

export default AuthService;

export {CsrfCookieRequestError};

export const authService = new AuthService(httpClient);
